import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuoteRetrievedModel, Scheme } from '../../models';

@Component({
    selector: 'view-quotes-button',
    templateUrl: './view-quotes-button.component.html'
})
export class ViewQuotesButtonComponent {
    private get quote() {
        return (this.activatedRoute.snapshot.data['quote'] as QuoteRetrievedModel) || null;
    }
    private get scope() {
        return (
            (this.activatedRoute.snapshot.data['scope'] as Scheme) ||
            (this.quote ? this.quote.quoteFormModel.scope : null)
        );
    }
    private get isEaas() {
        return (
            (this.activatedRoute.snapshot.data['isEaas'] as boolean) ||
            (this.quote ? this.quote.quoteFormModel.isEaas : null)
        );
    }
    get quoteListUrl() {
        if (this.isEaas) {
            switch (this.scope) {
                case Scheme.NewSouthWales:
                    return '/nsw-quotes-eaas';
                default:
                    return '/quotes-eaas';
            }
        }
        switch (this.scope) {
            case Scheme.SouthAustraliaPowerNetworks:
                return '/sapn-quotes';
            case Scheme.NewSouthWales:
                return '/nsw-quotes';
            case Scheme.WesternAustralia:
                return '/quotes/list/wa';
            default:
                return '/quotes';
        }
    }

    constructor(private activatedRoute: ActivatedRoute) {}
}
